import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';

import { provideClientHydration } from '@angular/platform-browser';
import { provideCustomProviders } from './customer-providers';

export const appConfig: ApplicationConfig = {
  providers: [
    // Incremental hydration is the default with provideClientHydration since
    // Angular 22 (the explicit withIncrementalHydration() opt-in was removed).
    provideClientHydration(),
    // blockingInitialNavigation: the shell reads route data (stageExtension →
    // .shell-body--bleed) at construction. Hydration bootstraps before
    // DOMContentLoaded, so without a resolved snapshot the shell drops the class
    // the SSR HTML painted and re-adds it on NavigationEnd — two layout shifts.
    // See CustomProvidersOptions. Component tests deliberately omit this.
    provideCustomProviders({ blockingInitialNavigation: true }),
    provideBrowserGlobalErrorListeners(),
  ],
};
